import { render, staticRenderFns } from "./AjustesDeCliente.vue?vue&type=template&id=0e3e0a4b&scoped=true&"
import script from "./AjustesDeCliente.vue?vue&type=script&lang=js&"
export * from "./AjustesDeCliente.vue?vue&type=script&lang=js&"
import style0 from "./AjustesDeCliente.vue?vue&type=style&index=0&id=0e3e0a4b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3e0a4b",
  null
  
)

export default component.exports